import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllFacebookPageInfluencersV2.graphql';
import { Query, QueryallFacebookPageInfluencersV2Args } from '../../__generated__/globalTypes';

export const useAllFacebookPageInfluencersV2Query = (
  options?: QueryHookOptions<Query, QueryallFacebookPageInfluencersV2Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallFacebookPageInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllFacebookPageInfluencersV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallFacebookPageInfluencersV2Args>
): QueryResult<Query, QueryallFacebookPageInfluencersV2Args> & {
  getAllFacebookPageInfluencersV2: LazyQueryExecFunction<Query, QueryallFacebookPageInfluencersV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllFacebookPageInfluencersV2, result] = useLazyQuery<Query, QueryallFacebookPageInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllFacebookPageInfluencersV2, ...result };
};

export const useAllFacebookPageInfluencersV2PromiseQuery = () => {
  const client = useApolloClient();

  const getAllFacebookPageInfluencersV2 = useCallback(
    (options?: Omit<QueryOptions<QueryallFacebookPageInfluencersV2Args, Query>, 'query'>) =>
      client.query<Query, QueryallFacebookPageInfluencersV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllFacebookPageInfluencersV2 };
};
// Suspense Query Hooks
export const useAllFacebookPageInfluencersV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallFacebookPageInfluencersV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryallFacebookPageInfluencersV2Args>(QUERY, {
    ...options
  });

  return result;
};
